import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mobile-view',
  templateUrl: './mobile-view.component.html',
  styleUrls: ['./mobile-view.component.scss']
})
export class MobileViewComponent {

  readonly title = 'Welcome!';

  readonly messages = {
    mobile: `If you're on a mobile device, Rehab Connect works best on
      desktop. For the full experience, we recommend opening it on a computer.`,
    desktop: `If you're already using a desktop, try increasing or
      maximizing your browser window to see everything clearly.`
  };

  readonly footer = {
    learnMoreText: 'Learn more',
    learnMoreUrl: 'https://myzpax.com/welcome-to-zpax',
    learnMoreAbout: 'about',
    brandLogoSrc: '/assets/zpax-main-logo.svg',
    brandLogoAlt: 'myzPAX',
    copyright: `Copyright \u00A9 ${new Date().getFullYear()} All rights reserved. z-PAX Holdco, Inc. and its Subsidiaries and Affiliates`
  };

  readonly assets = {
    rcLogoSrc: '/assets/rc-logo.png',
    rcLogoAlt: 'Rehab Connect'
  };

  constructor(private router: Router) {}
}